"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GanymedePermissions = undefined;

var _ice = require("ice");

var _Permissions = require("../Permissions/Permissions");

// **********************************************************************
//
// Copyright (c) 2003-2017 ZeroC, Inc. All rights reserved.
//
// This copy of Ice is licensed to you under the terms described in the
// ICE_LICENSE file included in this distribution.
//
// **********************************************************************
//
// Ice version 3.7.0
//
// <auto-generated>
//
// Generated from file `GanymedePermissions/Permissions.ice'
//
// Warning: do not edit this file.
//
// </auto-generated>
//

const _ModuleRegistry = _ice.Ice._ModuleRegistry;
const Slice = _ice.Ice.Slice;

let GanymedePermissions = _ModuleRegistry.module("GanymedePermissions");

const iceC_GanymedePermissions_CreateProject_ids = ["::GanymedePermissions::CreateProject", "::Ice::Object", "::Permissions::AbstractPermission"];

GanymedePermissions.CreateProject = class extends _Permissions.Permissions.AbstractPermission {};

Slice.defineValue(GanymedePermissions.CreateProject, iceC_GanymedePermissions_CreateProject_ids[0], false);

GanymedePermissions.CreateProjectDisp = class extends _Permissions.Permissions.AbstractPermissionDisp {};

Slice.defineOperations(GanymedePermissions.CreateProjectDisp, undefined, iceC_GanymedePermissions_CreateProject_ids, 0);

const iceC_GanymedePermissions_ManageProject_ids = ["::GanymedePermissions::ManageProject", "::Ice::Object", "::Permissions::AbstractPermission"];

GanymedePermissions.ManageProject = class extends _Permissions.Permissions.AbstractPermission {
    constructor(projectId = undefined) {
        super();
        this.projectId = projectId;
    }

    _iceWriteMemberImpl(ostr) {
        _ice.Ice.StringHelper.writeOptional(ostr, 0, this.projectId);
    }

    _iceReadMemberImpl(istr) {
        this.projectId = _ice.Ice.StringHelper.readOptional(istr, 0);
    }
};

Slice.defineValue(GanymedePermissions.ManageProject, iceC_GanymedePermissions_ManageProject_ids[0], false);

GanymedePermissions.ManageProjectDisp = class extends _Permissions.Permissions.AbstractPermissionDisp {};

Slice.defineOperations(GanymedePermissions.ManageProjectDisp, undefined, iceC_GanymedePermissions_ManageProject_ids, 0);
exports.GanymedePermissions = GanymedePermissions;


//////////////////
// WEBPACK FOOTER
// ./~/@slices/GanymedePermissions/Permissions.js
// module id = 216
// module chunks = 0